import { render } from "./LayoutHeaderNew2.vue?vue&type=template&id=db819c48&scoped=true"
import script from "./LayoutHeaderNew2.vue?vue&type=script&lang=js"
export * from "./LayoutHeaderNew2.vue?vue&type=script&lang=js"

import "./LayoutHeaderNew2.vue?vue&type=style&index=0&id=db819c48&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db819c48"]])

export default __exports__